// extracted by mini-css-extract-plugin
module.exports = {"visuallyhidden":"index-module--visuallyhidden--3hJg8"};